import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  override: {
    // Убираем дефолтный конфликт между font-size и leading
    // (text-* классы по умолчанию считаются конфликтующими с leading-*)
    conflictingClassGroups: {
      "font-size": [],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
